import CarrierService from '@/plugins/sdk/resources/Carrier/Service'

export default class extends CarrierService {
  static name = 'service'
}
